import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { Observable, combineLatest, map } from 'rxjs';

import { whenTruthy } from 'ish-core/utils/operators';

import { DotCmsUveFacade } from '../../../facades/dot-cms-uve.facade';
import { Author, BlogContentlet } from '../../../models/dot-cms-uve-contentlet.model';
import { DotCmsCodecEncodePipe } from '../../../pipes/dot-cms-codec-encode.pipe';

@Component({
  selector: 'custom-dot-cms-blog-author',
  templateUrl: './dot-cms-uve-blog-author.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./dot-cms-uve-blog-author.component.scss'],
  imports: [AsyncPipe, DotCmsCodecEncodePipe],
})
export class DotCmsBlogAuthorComponent implements OnInit {
  dotCmsUveFacade = inject(DotCmsUveFacade);

  readonly isBlog = input<string>(undefined);
  readonly author = input<Author>(undefined);
  readonly isCommentAuthor = input<string>(undefined);
  readonly contentlet = input<BlogContentlet>(undefined);
  host$: Observable<string>;

  ngOnInit() {
    this.host$ = this.dotCmsUveFacade.getDotCmsHost$;
  }

  buildImageSrcForAuthor(): Observable<string> {
    return combineLatest([this.dotCmsUveFacade.getDotCmsHost$.pipe(whenTruthy())]).pipe(
      whenTruthy(),
      map(([host]) => `${host + this.author().profilePhoto.idPath}`)
    );
  }
}
